/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
const mobileFilters = () => {
  const mobileFiltersButton = document.querySelector('.js-show-mobile-filters');
  const mobileFiltersClose = document.querySelector('.js-close-filter-popup');
  const mobileOverlay = document.querySelector('.mobile-overlay');
  const searchFiltersForm = document.querySelector('.js-search-filters-form');

  if (
    typeof mobileFiltersButton !== 'undefined' &&
    mobileFiltersButton != null
  ) {
    mobileFiltersButton.addEventListener(
      'click',
      event => {
        mobileOverlay.classList.remove('u-hidden');
        mobileOverlay.classList.add('mobile-overlay--large-z-index');
        searchFiltersForm.parentElement.classList.add('is-active');
      },
      true,
    );
  }
  if (typeof mobileFiltersClose !== 'undefined' && mobileFiltersClose != null) {
    mobileFiltersClose.addEventListener(
      'click',
      event => {
        event.preventDefault();
        mobileOverlay.classList.add('u-hidden');
        mobileOverlay.classList.remove('mobile-overlay--large-z-index');
        searchFiltersForm.parentElement.classList.remove('is-active');
      },
      true,
    );
  }

  const filteropen = document.querySelectorAll('.js-filteropen');
  filteropen.forEach(filter => {
    filter.addEventListener(
      'click',
      event => {
        event.preventDefault();
        const filterContent = filter.nextElementSibling;
        document.querySelectorAll('.js-filteropen-trigger').forEach(el => {
          if (el !== filter.nextElementSibling) {
            el.classList.remove('is-active');
            el.parentElement
              .querySelector('.js-filteropen')
              .classList.remove('is-active');
          }
        });
        filterContent.classList.toggle('is-active');
        filter.classList.toggle('is-active');
      },
      true,
    );
  });
  const allfilters = document.querySelector('.js-allfilters');
  if (allfilters) {
    allfilters.addEventListener('click', event => {
      event.preventDefault();
      allfilters.parentElement.classList.toggle('is-small');
      document.querySelectorAll('.c-label__container').forEach(e => {
        e.classList.remove('is-active');
      });
    });
  }
  const filtersLink = document.querySelector('.js-filters');
  if (filtersLink) {
    filtersLink.addEventListener('click', event => {
      event.preventDefault();
      document.querySelector('.c-search-filters').style.display = 'block';
    });
  }
  const filtersClose = document.querySelector('.js-close-filter-popup');
  if (filtersClose) {
    filtersClose.addEventListener('click', event => {
      event.preventDefault();
      document.querySelector('.c-search-filters').style.display = 'none';
    });
  }
  document.addEventListener('click', e => {
    if (
      !document.querySelector('body').classList.contains('parent-pageid-1563')
    ) {
      if (e.target.closest('.c-filters__list')) {
        // console.log('clicked inside');
      } else {
        document.querySelectorAll('.c-label__container').forEach(el => {
          el.classList.remove('is-active');
          console.log(el);
        });
      }
    }
  });
};

export default mobileFilters;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/mobileFilters.js